import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {addEditPurchase, changeStatusPurchase, delPurchase, getPurchases, removeApprovalPurchase} from '../../services';
import {IPurchase, IPurchaseFilter, IPurchaseRes, IPurchaseState} from "../types/IPurchase";
import historyHelper from "../../helpers/history";
import {AppState} from "./rootReducer";
import {updatePurchaseItem} from "./patientsReducer";
import {ESTADO_COMPRA} from "../../helpers/CONSTANTES";

const initialState: IPurchaseState = {
    status: "idle"
}

export const mostrarPurchases = createAsyncThunk(
    'mostrarPurchases', async (params:IPurchaseFilter|undefined, thunkAPI ) => {
        const {purchases} = thunkAPI.getState() as AppState;
        let paramsFilter = params || purchases.filtered;

        const response = await getPurchases(paramsFilter)
        return {data: response.data as IPurchaseRes, params: response.config.params}
    }
)

export const agregarEditarPurchase = createAsyncThunk(
    'Purchases/agregarEditar', async (purchase: IPurchase, thunkAPI) => {
        const response = await addEditPurchase(purchase);
        if ((response.status === 200 || response.status === 204) && !!purchase.id) {
            historyHelper.back()
        };

        return {data: response.data, edit:!!purchase.id};
    }
);
export const mostrarPurchaseById = createAsyncThunk(
    'mostrarPurchaseById', async (id:number,thunkAPI) => {
        // let byId = (thunkAPI.getState() as AppState)?.purchases?.list?.items?.find(c=>c.id === id);
        // if(byId){
        //     return {data: byId}
        // }

        const response = await getPurchases(id);
        return {data: response.data as IPurchase}
    }
)

export const eliminarPurchase = createAsyncThunk(
    'purchase/eliminar', async (id: number, thunkAPI) => {
        const response = await delPurchase(id);

        let patientById = (thunkAPI.getState() as AppState)?.patients?.byId

        if (response.status === 200 || response.status === 204) {
            if(!!patientById?.id){
                thunkAPI.dispatch(updatePurchaseItem({id, status: ESTADO_COMPRA.inactiva}))
            }
            historyHelper.back()
        };
        return id;
    }
);
export const cambiarEstadoPurchase = createAsyncThunk(
    'purchase/estado', async (param: IPurchase, thunkAPI) => {
        const response = await changeStatusPurchase(param);
        let patientById = (thunkAPI.getState() as AppState)?.patients?.byId


        if ((response.status === 200 || response.status === 204) && patientById?.id) {
            thunkAPI.dispatch(updatePurchaseItem(response.data))
        }

        return response.data;
    }
);
export const deshacerAprobacionPurchase  = createAsyncThunk(
    'purchase/DeshacerAprobacion', async (id: number, thunkAPI) => {
         await removeApprovalPurchase(id);


        return {id, status: ESTADO_COMPRA.pendiente};
    }
);


const slice = createSlice({
    name: 'mostrarPurchases',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarPurchases
        builder.addCase(mostrarPurchases.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarPurchases.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarPurchases.rejected, (state ) => {
            state.status = "idle";
        })

        //--agregarEditarPurchase
        builder.addCase(agregarEditarPurchase.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(agregarEditarPurchase.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list?.items.filter(e => e.id !== action.payload.data.id);
                state.list.items.unshift(action.payload.data);
                if(!action.payload.edit){
                    ++state.list.pageSize
                    ++state.list.totalCount
                }

            }
        })
        builder.addCase(agregarEditarPurchase.rejected, (state ) => {
            state.status = "idle";
        })
        //--mostrarPurchaseById
        builder.addCase(mostrarPurchaseById.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarPurchaseById.fulfilled, (state,action ) => {
            state.status = "idle";
            state.byId = action.payload.data;
        })
        builder.addCase(mostrarPurchaseById.rejected, (state ) => {
            state.status = "idle";
        })

        //--eliminarPurchase
        builder.addCase(eliminarPurchase.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(eliminarPurchase.fulfilled, (state,action ) => {
            state.status = "idle";
            const id = action.payload;
            if(state.list?.items){
                state.list.items = state.list?.items?.map(item=>{
                    if(item.id === id){
                        return {...item, status: ESTADO_COMPRA.inactiva}
                    }
                    return item;
                })
            }
            if(state.byId){
                state.byId = {...state.byId, status: ESTADO_COMPRA.inactiva}
            }
        })
        builder.addCase(eliminarPurchase.rejected, (state ) => {
            state.status = "idle";
        })
        //--cambiarEstadoPurchase
        builder.addCase(cambiarEstadoPurchase.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(cambiarEstadoPurchase.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list.items.map(item=>{
                    if(item.id === action.payload?.id){
                        return {...item, ...action.payload}
                    }
                    return item
                })
            }
            if(state.byId && state.byId.id === action.payload?.id){
                state.byId = {...state.byId, ...action.payload}
            }
        })
        builder.addCase(cambiarEstadoPurchase.rejected, (state ) => {
            state.status = "idle";
        })
        //--deshacerAprobacionPurchase
        builder.addCase(deshacerAprobacionPurchase.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(deshacerAprobacionPurchase.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list.items.map(item=>{
                    if(item.id === action.payload?.id){
                        return {...item, ...action.payload}
                    }
                    return item
                })
            }
            if(state.byId && state.byId.id === action.payload?.id){
                state.byId = {...state.byId, ...action.payload}
            }
        })
        builder.addCase(deshacerAprobacionPurchase.rejected, (state ) => {
            state.status = "idle";
        })
    }
});

export default slice.reducer;
